module.exports = __webpack_public_path__ + "zvetseni-rtu-permalip_1_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zvetseni-rtu-permalip_1_before_tn.jpg
// module id = 1842
// module chunks = 0